import { SubscriptionOptions as SubscriptionOptionsNew } from "./components";

const UpgradePage = () => {
  return (
    <div className="relative">
      <CheckoutForm />
    </div>
  );
};

export default UpgradePage;

function CheckoutForm() {
  return (
    <div className="relative mt-8">
      <SubscriptionOptionsNew showNavigateBack={true} />
    </div>
  );
}
